import { FirestoreCollection } from './FirestoreCollection';
import { FirestoreRepository } from './FirestoreRepository';
import { DataCallback } from '../DataCallback';

export abstract class CollectionRepository extends FirestoreRepository {
  private _collection?: FirestoreCollection;

  abstract readonly collectionName: string;

  public get collection(): any {
    if (!this._collection) {
      this._collection = new FirestoreCollection(this
        .firestoreRepository
        .collection
        .collection
        .doc(this._id)
        .collection(this.collectionName)
      );
    }
    return this._collection;
  }

  public constructor(private _id: string, private firestoreRepository: FirestoreRepository) {
    super();
  }
}

export class TaskRepository extends CollectionRepository {
  static readonly COLLECTION_NAME = 'tasks';
  public get collectionName(): string {
    return TaskRepository.COLLECTION_NAME;
  }
}

export class TaskThreadRepository extends CollectionRepository {
  static readonly COLLECTION_NAME = 'threads';
  public get collectionName(): string {
    return TaskThreadRepository.COLLECTION_NAME;
  }
}

export class TaskThreadCommentRepository extends CollectionRepository {
  static readonly COLLECTION_NAME = 'comments';
  public get collectionName(): string {
    return TaskThreadCommentRepository.COLLECTION_NAME;
  }
}

export class TalkThreadRepository extends CollectionRepository {
  static readonly COLLECTION_NAME = 'talks';
  public get collectionName(): string {
    return TalkThreadRepository.COLLECTION_NAME;
  }
}

export class TalkThreadCommentRepository extends CollectionRepository {
  static readonly COLLECTION_NAME = 'comments';
  public get collectionName(): string {
    return TalkThreadCommentRepository.COLLECTION_NAME;
  }
}

export class ConsultationRepository extends CollectionRepository {
  static readonly COLLECTION_NAME = 'consultations';
  public get collectionName(): string {
    return ConsultationRepository.COLLECTION_NAME;
  }
}

export class ConsultationCommentRepository extends CollectionRepository {
  static readonly COLLECTION_NAME = 'comments';
  public get collectionName(): string {
    return ConsultationCommentRepository.COLLECTION_NAME;
  }
}

export class NoteThreadRepository extends CollectionRepository {
  static readonly COLLECTION_NAME = 'notes';
  public get collectionName(): string {
    return NoteThreadRepository.COLLECTION_NAME;
  }
}

export class NoteThreadCommentRepository extends CollectionRepository {
  static readonly COLLECTION_NAME = 'comments';
  public get collectionName(): string {
    return NoteThreadCommentRepository.COLLECTION_NAME;
  }
}

export class AnnouncementThreadRepository extends CollectionRepository {
  static readonly COLLECTION_NAME = 'announcements';
  public get collectionName(): string {
    return AnnouncementThreadRepository.COLLECTION_NAME;
  }
}